import { IconBarcodeScanner } from "@tine/designsystem-icons/sharp";
import { observer } from "mobx-react-lite";

import useMediaQuery from "../../common/useMediaQuery";
import { mediaQueries } from "../../common/utils";

import barcodeStore from "../../stores/barcodeStore";
import featuresStore from "../../stores/features/featuresStore";

import Button from "../Button";

type BarcodeScannerButtonProps = {
   [key: string]: unknown;
};

const BarcodeScannerButton = (props: BarcodeScannerButtonProps) => {
   const isDesktop = useMediaQuery(mediaQueries.xl);
   if (!featuresStore.barcodeScannerEnabled) {
      return null;
   }

   return (
      <div {...props}>
         <Button
            icon={<IconBarcodeScanner />}
            iconPosition="left"
            variant="tertiary"
            size={isDesktop ? "regular" : "iconOnly"}
            onClick={barcodeStore.showModal}
            trackingName="Skanner"
         >
            Skanner
         </Button>
      </div>
   );
};

export default observer(BarcodeScannerButton);
